import Button from "../../../Components/Button";
import Form from "../../../Components/Form";
import TextInput from "../../../Components/TextInput";
import {
  IAddEditRoleFormValues,
  IPermissionTreeNode,
} from "../../../Interfaces/roleAndPermissionsInterfaces";
import { getPermissionTree } from "../../../Requests/roleAndPermissionsRequests";
import { useEffect, useState } from "react";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import { CheckBox } from "src/Components";
import PermissionPickerModal from "./PermissionPickerModal";

interface IProps {
  formValues: IAddEditRoleFormValues;
  onChange: (name: string, value: any) => void;
  onBtnClick: () => void;
  loading: boolean;
  onEditCancel: () => void;
}

const AddEditForm = ({
  formValues,
  onChange,
  onBtnClick,
  loading,
  onEditCancel,
}: IProps) => {
  const [permissions, setPermissions] = useState<IPermissionTreeNode[]>([]);
  const [permissionsLoading, setPermissionsLoading] = useState(true);

  useEffect(() => {
    getPermissionTree()
      .then(setPermissions)
      .catch(packetErrorHandler)
      .finally(() => setPermissionsLoading(false));
  }, []);

  return (
    <Form className="py-3 px-2 gap-3 !w-80">
      <TextInput
        label="نام نقش"
        value={formValues.roleName}
        name="roleName"
        onChange={onChange}
        disabled={!!formValues.roleId}
      />

      <PermissionPickerModal
        options={permissions}
        value={formValues.permissionIds}
        loading={permissionsLoading}
        onChange={(value) => onChange("permissionIds", value)}
      />
      <CheckBox
        label="دسترسی خصوصی"
        checked={formValues.isPrivate}
        onChange={onChange}
        name="isPrivate"
      />
      <Button
        text={formValues.roleId ? "ویرایش کردن" : "اضافه کردن"}
        onClick={onBtnClick}
        variant="contained"
        loading={loading}
      />
      {formValues.roleId ? (
        <Button
          text="لغو ویرایش"
          onClick={onEditCancel}
          variant="outlined"
          loading={loading}
        />
      ) : (
        <></>
      )}
    </Form>
  );
};

export default AddEditForm;
